import ShopifyVariants from '@pixelunion/shopify-variants';
import ShopifySurfacePickUp from '@pixelunion/shopify-surface-pick-up';

import Modal from './Modal';

export default class ProductDetails {
  constructor(options) {
    this.el = options.el;
    this.product = options.product;
    this.settings = options.settings;
    this.onVariantChange = options.onVariantChange || (() => {});

    this.variantFields = {
      price: this.el.querySelector('[data-product-price]'),
      priceCompare: this.el.querySelector('[data-product-price-compare]'),
      taxLine: this.el.querySelector('[data-tax-line]'),
      unitPrice: this.el.querySelector('[data-unit-price]'),
      totalQuantity: this.el.querySelector('[data-total-quantity]'),
      unitPriceAmount: this.el.querySelector('[data-unit-price-amount]'),
      unitPriceMeasure: this.el.querySelector('[data-unit-price-measure]'),
      atcButton: this.el.querySelector('[data-product-atc]'),
      atcButtonText: this.el.querySelector('[data-product-atc-text]'),
    };

    this.variants = this.el.querySelector('[data-variants]');

    if (!this.product) return;

    this.surfacePickUp = new ShopifySurfacePickUp(this.el.querySelector('[data-surface-pick-up]'));

    if (this.variants) {
      this.options = this.el.querySelectorAll('[data-product-option]');
      this.enableHistory = !this.isThemeEditor && history.replaceState && this.settings.enableHistory;

      this.variantHelper = new ShopifyVariants(
        this.product,
        this.variants,
        this.options,
        { onSwitchVariant: data => this._onSwitchVariant(data) },
      );
    }

    const selectedVariant = () => (this.variantHelper
      ? this.variantHelper.getSelectedVariant()
      : this.product.variants[0]); // product has only default variant

    this.modal = new Modal({
      onClose: () => this.modal.unload(),
      modalId: 1,
    });

    this.surfacePickUp.load(selectedVariant().id);
    this.surfacePickUp.onModalRequest(contents => {
      let container = this.el.querySelector('[data-surface-pick-up-modal-contents]');

      const variantTitle = this.variantHelper
        ? `<div class="surface-pick-up-modal__variant">${selectedVariant().title}</div>`
        : '';

      const modalContents = `
        <div class="surface-pick-up-modal__header">
          <h2 class="surface-pick-up-modal__title">${this.product.title}</h2>
          ${variantTitle}
        </div>
        ${contents}
        `;

      if (!container) {
        container = document.createElement('div');
        container.setAttribute('data-surface-pick-up-modal-contents', '');
        container.style.display = 'none';

        container.innerHTML = modalContents;
        this.el.querySelector('.product-details__form').appendChild(container);
      } else {
        container.innerHTML = modalContents;
      }

      this.modal.open('[data-surface-pick-up-modal-contents]', 'surface-pick-up');
    });
  }

  unload() {
    if (this.variantHelper) {
      this.variantHelper.unload();
    }
  }

  _updatePrice(variant) {
    const {
      price,
      priceCompare,
      atcButton,
      atcButtonText,
    } = this.variantFields;

    const variantPrice = Shopify.formatMoney(variant.price, window.Theme.moneyFormat);
    const variantComparePrice = Shopify.formatMoney(variant.compare_at_price, window.Theme.moneyFormat);

    if (variant.available) {
      atcButtonText.innerText = this.settings.addToCartText;
      atcButton.disabled = false;
    } else {
      atcButtonText.innerText = this.settings.soldOutText;
      atcButton.disabled = true;
    }

    price.innerHTML = variantPrice;

    if (variant.compare_at_price > variant.price) {
      price.classList.add('product-price__minimum--sale');
      priceCompare.innerHTML = variantComparePrice;
      priceCompare.classList.remove('product-price__compare--hidden');
    } else {
      price.classList.remove('product-price__minimum--sale');
      priceCompare.innerHTML = '';
      priceCompare.classList.add('product-price__compare--hidden');
    }
  }

  _updateTaxLine(variant) {
    const { taxLine } = this.variantFields;

    if (!taxLine) return;

    if (variant.taxable) {
      taxLine.classList.remove('product-details__tax-label--hidden');
    } else {
      taxLine.classList.add('product-details__tax-label--hidden');
    }
  }

  _updateUnitPrice(variant) {
    const {
      unitPrice,
      totalQuantity,
      unitPriceAmount,
      unitPriceMeasure,
    } = this.variantFields;

    if (unitPrice && variant.unit_price_measurement) {
      totalQuantity.innerHTML = `${variant.unit_price_measurement.quantity_value}${variant.unit_price_measurement.quantity_unit}`;

      unitPriceAmount.innerHTML = Shopify.formatMoney(variant.unit_price, window.Theme.moneyFormat);
      if (variant.unit_price_measurement.reference_value === 1) {
        unitPriceMeasure.innerHTML = variant.unit_price_measurement.reference_unit;
      } else {
        unitPriceMeasure.innerHTML = `${variant.unit_price_measurement.reference_value}${variant.unit_price_measurement.reference_unit}`;
      }
      unitPrice.classList.remove('product-details__unit-price--hidden');
    } else if (unitPrice) {
      unitPrice.classList.add('product-details__unit-price--hidden');
    }
  }

  _updateHistory(variant) {
    if (!this.enableHistory) return;

    const newUrl = [
      window.location.protocol,
      '//',
      window.location.host,
      window.location.pathname,
      '?variant=',
      variant.id,
    ];

    const variantUrl = newUrl.join('');
    window.history.replaceState({ path: variantUrl }, '', variantUrl);
  }

  _onSwitchVariant({ product, variant }) {
    this._updatePrice(variant);
    this._updateTaxLine(variant);
    this._updateUnitPrice(variant);
    this._updateHistory(variant);
    this.onVariantChange({ product, variant });
    this.surfacePickUp.load(variant.id);
  }
}
